const path = window.location.pathname

export const getPath = () => {
  return path.includes('/enroll-company')
    ? 'enroll-company'
    : 'identity-verification'
}
